export default "/kiban/_next/static/images/clear-c1804a3f9f347a2963ce5bf37ab848b1.png";